//TODO: API (https://openweathermap.org/api/current?collection=current_forecast)

import { onFormSubmit } from './handlers';
import { refs } from './refs';
/*
TODO: Weather card template:

<div class="weather-card">
  <h2 class="city-name"></h2>
  <ul class="weather-info list">
    <li class="weather-info-item">
        <p class="temp">Температура: <sup>&#176;</sup></p>
    </li>
    <li class="weather-info-item">
        <p class="feels-like-temp">Відчувається як: <sup>&#176;</sup></p>
    </li>
    <li class="weather-info-item">
        <p class="sunrise-time">Схід сонця: </p>
    </li>
    <li class="weather-info-item">
        <p class="sunset-time">Захід сонця: </p>
    </li>
    <li class="weather-info-item">
        <p class="clouds">Хмарність: %</p>
    </li>
  </ul>
</div>
*/

refs.form.addEventListener('submit', onFormSubmit);
